import "./Blog.css";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import Posts from "./BlogComponents/Posts";

const Blogs = () => {
  return (
    <>
      <NavBar />
      <Posts />
      <Footer />
    </>
  );
};

export default Blogs;
